export default __webpack_public_path__ + "static/media/Touching_Moment.9ed66a68.mp3";